import { TextField, Checkbox } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import React, { useEffect, useState, useMemo } from "react";
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

import constants from '../../../constants';
import { getSearchResults } from '../../../store/Auth';
import { setActiveActivityBox, createRelation } from '../../../store/Activities';

const CreateRelation = ({ type = 'existing', activity, initialAssociations = {} }) => {

   const dispatch = useDispatch();
   let { activeActivityBox } = useSelector(state => state['Activities']);
   let { user, searchResponse, isLoadButton } = useSelector(state => state['Auth']);

   let hardObjectsSchema = constants.getObjectSchema('hard');
   let objectsArray = Object.values(hardObjectsSchema); // Get array of all object schemas

   // Initialize selected state with all entity types from schema
   const getInitialSelected = () => {
      const initial = {};
      objectsArray.forEach(obj => { initial[obj['plural']] = initialAssociations[obj['plural']] || []; });
      return initial;
   };

   let [searchValue, setSearchValue] = useState('');
   let [showAssociated, setShowAssociated] = useState(false);
   let [selected, setSelected] = useState(getInitialSelected);
   let [selectObject, setSelectObject] = useState(objectsArray[0]);

   // Sync local state with initialAssociations prop when it changes
   useEffect(() => {
      setSelected(getInitialSelected());
   }, [JSON.stringify(initialAssociations)]);

   useEffect(() => {
      if (showAssociated) {
         const timer = setTimeout(() => { dispatch(getSearchResults({ search: searchValue, objects: objectsArray.map(item => item['plural']) })) }, 500);
         return () => clearTimeout(timer);
      }
   }, [searchValue, showAssociated]);
   useEffect(() => {
      if (showAssociated) dispatch(getSearchResults({ search: '', objects: objectsArray.map(item => item['plural']) }));
   }, [showAssociated]);

   const handleRelatedChecked = (e, id, object) => {
      const newSelected = { ...selected };
      const selectedKey = object['plural'];

      if (e['target']['checked']) {
         // Add ID if not already present
         if (!newSelected[selectedKey]?.includes(id)) newSelected[selectedKey] = [...(newSelected[selectedKey] || []), id];
      } else {
         // Remove ID
         newSelected[selectedKey] = newSelected[selectedKey]?.filter(item => item !== id);
      }

      setSelected(newSelected);

      // Update Redux store based on object type
      if (type === 'new') dispatch(setActiveActivityBox({ activityBox: activeActivityBox, associations: newSelected, sourceId: 'related' }));
      else if (type === 'existing') dispatch(createRelation({ relationType: `activity_${object['name']}`, sourceId: activity['_id'], targetId: id, action: e['target']['checked'] ? 'add' : 'remove' }));
   }

   // Calculate total selected count
   const totalSelected = Object.values(selected).reduce((sum, arr) => sum + arr.length, 0);

   return (
      <div className={`group-form for-group style-two d-flex justify-content-between`}>
         {type === 'new' && totalSelected > 0 && <div className="for-left">
            {Object.entries(selected).map(([key, array]) => {
               const schema = constants.getObjectSchema(key);
               const pluralKey = schema?.['plural'];
               return <>
                  {searchResponse?.['results']?.[pluralKey] && array.map(id => {
                     const item = searchResponse['results'][pluralKey].find(item => item['_id'] === id);
                     if (!item) return null;
                     return <div className="for-box" key={id}>{item['displayInfo']?.['shortHeading']}</div>
                  })}
               </>
            })}
         </div>}
         <div className="right-area" style={{ textAlign: 'right' }}>
            <div className="associted-box" style={{ display: 'inline-block' }}>
               <Dropdown isOpen={showAssociated} toggle={() => setShowAssociated(!showAssociated)}>
                  <DropdownToggle caret>
                     Related with {totalSelected} Object{totalSelected !== 1 ? 's' : ''}
                     <i className="icon">
                        <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path d="M3.74219 2.40453L2.38875 0L0.385372 0C0.0425479 0 -0.128864 0.552327 0.113969 0.876105L1.96379 3.34253C2.26019 3.73773 2.74229 3.73773 3.03868 3.34253L3.74219 2.40453Z" fill="var(--primary-color)" />
                           <path d="M4.61365 0L2.38887 0L3.74231 2.40453L4.88863 0.876105C5.12789 0.552327 4.95648 0 4.61365 0Z" fill="var(--primary-color)" />
                        </svg>
                     </i>
                  </DropdownToggle>
                  <DropdownMenu end className="create-relation-menu">
                     <div className="dropdown-area-associated" >
                        <div className="left-area">
                           <div className="box-area">
                              <button className={selectObject['name'] == 'Selected' && 'active'} onClick={() => setSelectObject({ 'name': 'Selected' })}>Selected ({totalSelected})</button>
                              <hr style={{ margin: '5px 0' }} />
                              {objectsArray.map(object => <button className={selectObject['name'] == object['name'] && 'active'} onClick={() => setSelectObject(object)}>{object['labels']}</button>)}
                           </div>
                        </div>
                        <div className="right-side-area">
                           {selectObject['name'] != 'Selected' &&
                              <div className='searchbox'>
                                 <TextField
                                    autoFocus
                                    fullWidth
                                    size='small'
                                    variant='standard'
                                    value={searchValue}
                                    placeholder='Search...'
                                    onChange={(e) => setSearchValue(e['target']['value'])}
                                 />
                                 <i class='icon'><svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M5.40156 10.6464C2.74292 10.6464 0.578369 8.48183 0.578369 5.82319C0.578369 3.16455 2.74292 1 5.40156 1C8.0602 1 10.2248 3.16455 10.2248 5.82319C10.2248 8.48183 8.0602 10.6464 5.40156 10.6464ZM5.40156 1.70583C3.12878 1.70583 1.2842 3.55511 1.2842 5.82319C1.2842 8.09127 3.12878 9.94055 5.40156 9.94055C7.67434 9.94055 9.51892 8.09127 9.51892 5.82319C9.51892 3.55511 7.67434 1.70583 5.40156 1.70583Z' fill='#50525870' stroke='#50525870' stroke-width='0.236842' /><path d='M12.8959 13.7066C12.8021 13.7068 12.7083 13.6723 12.6342 13.5984L8.68189 9.63155C8.5386 9.48864 8.53829 9.2518 8.68119 9.10852C8.82409 8.96524 9.06094 8.96492 9.20422 9.10783L13.1565 13.0747C13.2998 13.2176 13.3001 13.4545 13.1572 13.5977C13.0833 13.6718 12.9896 13.7065 12.8959 13.7066Z' fill='#50525870' stroke='#50525870' stroke-width='0.236842' /></svg></i>
                              </div>
                           }

                           {isLoadButton ? <div className="bottom-detail-area"><p style={{ fontSize: '12px' }}><i className='fa fa-spinner fa-spin'></i> Fetching {selectObject['name']}...</p ></div>
                              : selectObject['name'] === 'Selected' ? <>
                                 {/* Show selected items if any */}
                                 <div className="bottom-detail-area" style={{ marginTop: '10px' }}>
                                    {Object.entries(selected).map(([key, array]) => {
                                       const schema = constants.getObjectSchema(key);
                                       const pluralKey = schema?.['plural'] || key.toLowerCase();
                                       return (
                                          <>
                                             {array.length > 0 &&
                                                <>
                                                   <h4 style={{ fontSize: '12px', marginBottom: '8px' }}>{schema['labels']} ({array.length})</h4>
                                                   {searchResponse?.['results']?.[pluralKey] && array.map(id => {
                                                      const item = searchResponse['results'][pluralKey].find(item => item['_id'] === id);
                                                      if (!item) return null;
                                                      return (
                                                         <label key={id} style={{ display: 'block', marginBottom: '4px' }}>
                                                            <Checkbox onChange={(e) => handleRelatedChecked(e, id, schema || { plural: key })} checked={true} />
                                                            {item['displayInfo']['shortHeading']}
                                                         </label>
                                                      )
                                                   })}
                                                </>
                                             }
                                          </>
                                       );
                                    })}
                                 </div>
                              </>
                                 : !searchResponse?.['results']?.[selectObject['plural']] || searchResponse?.['results']?.[selectObject['plural']].length === 0 ? <div className="bottom-detail-area"> <p style={{ fontSize: '12px' }}>No {selectObject['plural']} found</p></div>
                                    : <div className="bottom-detail-area">
                                       {searchResponse?.['results']?.[selectObject['plural']] && searchResponse['results'][selectObject['plural']]?.map(item => {
                                          const selectedKey = selectObject['plural'];
                                          const isChecked = selected[selectedKey]?.includes(item['_id']) || false;
                                          return (
                                             <label key={item['_id']}>
                                                <Checkbox
                                                   onChange={(e) => handleRelatedChecked(e, item['_id'], selectObject)}
                                                   checked={isChecked}
                                                />
                                                {item['displayInfo']['shortHeading']}
                                             </label>
                                          )
                                       })}
                                    </div>
                           }
                        </div>
                     </div>
                  </DropdownMenu>
               </Dropdown>
            </div></div>
      </div>
   )
}

export default CreateRelation;